module.exports = " <div class=wrapper> <router-view></router-view> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
 ** module id = 68
 ** module chunks = 0
 **/